import { render, staticRenderFns } from "./holographic.vue?vue&type=template&id=0269e8ba&scoped=true&"
import script from "./holographic.vue?vue&type=script&lang=js&"
export * from "./holographic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0269e8ba",
  null
  
)

export default component.exports